<script setup>
</script>

<template>
  <nav>
    <a href="/">
      <h1 class="title">鷲組!!</h1>
    </a>
    <div>東北楽天ゴールデンイーグルスファン集いの場</div>
  </nav>
</template>

<style scoped>
h1 {
  font-size: 2.5em;
  margin: 0;
  padding: 0;
}

a {
  display: inline-block;
  color: #383c3c;
  text-decoration: none;
}

ul {
  display: flex;
  padding: 0;
}

li {
  display: inline-block;
  flex: auto;
  padding: 0;
  width: 80px;
  list-style: none;
}

.text {
  font-size: .9em;
}
</style>